<div class="btn-group btn-block" dropdown>
  <button dropdownToggle type="button" id="multiselect" [ngClass]="{ 'is-invalid': hasError}"
      class="btn btn-light form-control btn-block input-btn" [tooltip]="getToolTip()"  placement="top"
       (click)="toggleDropdown();">
       <span class="pull-left" *ngIf="selectedItems.length == 0">{{_placeholder}}</span>
       <span style="margin-right:2px;" *ngFor="let item of selectedItems;let k = index" 
       [hidden]="k > _settings.itemsShowLimit-1"> 
        {{item.text}}{{k == selectedItems.length - 1? ' ' : k == _settings.itemsShowLimit-1 ? ' ':', '}}
        <!-- <a style="padding-top:2px;padding-left:2px;color:white" (click)="onItemClick($event,item)">x</a> -->
      </span>
      <span>
        <span style="padding-right: 6px;" *ngIf="itemShowRemaining()>0">+{{itemShowRemaining()}}</span>
        <span [ngClass]="_settings.defaultOpen ? 'dropdown-up' : 'dropdown-down'"></span>
      </span>
    </button>
    <ul *dropdownMenu class="dropdown-menu dropdown-menu-right scrollable-menu" role="menu">
      <li role="menuitem" class="filter-textbox" *ngIf="_settings.allowSearchFilter">
        <input type="text" (keypress)="keyPressAlphaNumeric($event)" [placeholder]="_settings.searchPlaceholderText" [(ngModel)]="filter.text" (ngModelChange)="onFilterTextChange($event)" (click)="$event.stopPropagation();">
      </li>
      <li role="menuitem" *ngFor="let item of _data;" (click)="onItemClick($event, item)">
        <div class="dropdown-item">
          <input type="checkbox" aria-label="multiselect-item" [checked]="isSelected(item)"
          [disabled]="isLimitSelectionReached() && !isSelected(item)" />
          {{item.text}}
        </div>
      </li>
      <li role="menuitem" class='no-data' *ngIf="_data.length == 0">
        <div class="dropdown-item">{{_settings.noDataAvailablePlaceholderText}}</div>
      </li>
    </ul>
</div>